import { Portal } from "@circle-react-uikit/Portal";

import type { StandardLayoutHeaderProps } from ".";
import { StandardLayoutHeader } from ".";

const childId = "standard-layout-header-child";

export const StandardLayoutHeaderWithPortal = ({
  children,
  ...props
}: StandardLayoutHeaderProps) => (
  <Portal selectorQuery="#standard-layout-header">
    <StandardLayoutHeader {...props} id={childId} />
    {children}
  </Portal>
);
